import Vue from "vue";
import vacanciesService from "../../services/vacant/vacant";
import { Vacant } from "../../services/vacant/entities/vacant.interface";
import { uploadTask, deleteTask } from "../../firebase";
import constants from "../../config/constants";
import { VacantState } from "./states/vacant.state.interface";

export default {
  namespaced: true,
  state: {
    vacancies: [],
    totalVacancies: 0
  },
  getters: {
    getVacancies: (state: VacantState) => state.vacancies,
    getTotalVacancies: (state: VacantState) => state.totalVacancies
  },
  mutations: {
    setVacancies(state: VacantState, vacancies: Array<Vacant>) {
      Vue.set(state, "vacancies", vacancies);
    },
    setTotalVacancies(state: VacantState, totalVacancies: number) {
      Vue.set(state, "totalVacancies", totalVacancies);
    }
  },
  actions: {
    getVacancies: async (context: any, payload: any) => {
      context.commit("setVacancies", []);
      await vacanciesService.getVacancies(payload).then((response: any) => {
        context.commit("setTotalVacancies", response.data.totalVacancies);
        context.commit("setVacancies", response.data.vacancies);
      });
    },
    getVacanciesToClient: async (context: any, payload: any) => {
      context.commit("setVacancies", []);
      await vacanciesService
        .getVacanciesToClient(payload)
        .then((response: any) => {
          context.commit("setTotalVacancies", response.data.totalVacancies);
          context.commit("setVacancies", response.data.vacancies);
        });
    },
    createVacant: async (context: any, payload: any) => {
      let created = false;
      await vacanciesService
        .createVacant(payload)
        .then(async (response: any) => {
          created = response.data.created;
          const photoURL = await uploadTask(
            response.data.vacantID,
            constants.TABLE.VACANT,
            payload.photoUrl
          );
          await vacanciesService.updateVacant({
            vacantId: response.data.vacantID,
            photoUrl: photoURL
          });
          await vacanciesService.getVacancies(payload).then((response: any) => {
            context.commit("setTotalVacancies", response.data.totalVacancies);
            context.commit("setVacancies", response.data.vacancies);
          });
        });
      return created;
    },
    updateVacant: async (context: any, payload: any) => {
      let updated = false;
      if (payload.newPhoto) {
        const photoURL = await uploadTask(
          payload.vacantId,
          constants.TABLE.VACANT,
          payload.photoUrl
        );
        payload.photoUrl = photoURL;
        await deleteTask(payload.currentPhoto);
      }
      await vacanciesService
        .updateVacant(payload)
        .then(async (response: any) => {
          updated = response.data.updated;
          await vacanciesService.getVacancies(payload).then((response: any) => {
            context.commit("setTotalVacancies", response.data.totalVacancies);
            context.commit("setVacancies", response.data.vacancies);
          });
        });
      return updated;
    },
    deleteVacant: async (context: any, payload: any) => {
      let deleted = false;
      await vacanciesService
        .deleteVacant(payload.vacantId)
        .then(async (response: any) => {
          deleted = response.data.deleted;
          await deleteTask(payload.vacantPhotoURL);
          await vacanciesService
            .getVacancies(payload)
            .then(async (response: any) => {
              if (payload.page > 1 && response.data.vacancies.length == 0) {
                payload.start =
                  (payload.page - 1) * constants.ITEMS_PER_PAGE -
                  constants.ITEMS_PER_PAGE;
                await vacanciesService
                  .getVacancies(payload)
                  .then((response: any) => {
                    context.commit(
                      "setTotalVacancies",
                      response.data.totalVacancies
                    );
                    context.commit("setVacancies", response.data.vacancies);
                  });
              } else {
                context.commit(
                  "setTotalVacancies",
                  response.data.totalVacancies
                );
                context.commit("setVacancies", response.data.vacancies);
              }
            });
        });
      return deleted;
    }
  }
};
